const styles = {
  footer: {
    padding: '16px 24px',
    textAlign: 'center',
    color: '#888',
    fontSize: '0.85rem',
  },
};

function Footer() {
  return (
    <footer style={styles.footer}>
      <p>&copy; 2026 VTuber検索</p>
    </footer>
  );
}

export default Footer;
